import { defineComponent as _defineComponent } from 'vue'
import { computed } from 'vue';
import { storeToRefs } from 'pinia';
import { useLanguageStore } from '@/stores/pinia/useLanguageStore';


export default /*#__PURE__*/_defineComponent({
  __name: 'GlobalHome',
  setup(__props) {

const GlobalHomeNew = () =>
	import(/* webpackChunkName: "global-home-new" */ '@/features/global-home/components/GlobalHomeNew.vue');
const GlobalHomeLegacy = () =>
	import(/* webpackChunkName: "global-home-legacy" */ '@/features/global-home/components/GlobalHomeLegacy.vue');

const NEW_START_PAGE_COUNTRIES = ['DE', 'AU'];

const { country } = storeToRefs(useLanguageStore());

const isNewStartPage = computed(() => NEW_START_PAGE_COUNTRIES.includes(country.value));

return { __sfc: true,GlobalHomeNew, GlobalHomeLegacy, NEW_START_PAGE_COUNTRIES, country, isNewStartPage }
}

})